import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import { getBulkEmailRecipients } from "../api";

export default function EmailRecipientsModal({ emailId, recipientCount, onClose }) {
  const [users, setUsers] = useState(null);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    getBulkEmailRecipients(emailId).then(setUsers);
  }, [emailId]);

  const filtered = users
    ? users.filter((u) => {
        const term = filter.toLowerCase();
        return (
          !term ||
          (u.username || "").toLowerCase().includes(term) ||
          (u.email || "").toLowerCase().includes(term)
        );
      })
    : [];

  return (
    <Dialog
      open
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ style: { backgroundColor: "#d8c8f4", color: "#4b445b" } }}
    >
      <DialogTitle>Recipients ({recipientCount})</DialogTitle>
      <DialogContent>
        <TextField
          autoComplete="off"
          margin="dense"
          fullWidth
          placeholder="Filter by username or email"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          disabled={!users}
        />
        {!users ? (
          <CircularProgress size={24} sx={{ display: "block", margin: "24px auto" }} />
        ) : (
          <List dense sx={{ maxHeight: 400, overflow: "auto" }}>
            {filtered.length ? (
              filtered.map((u) => (
                <ListItem key={u.id} disableGutters>
                  <ListItemText
                    primary={u.username || u.email || u.id}
                    secondary={u.username && u.email ? u.email : null}
                    primaryTypographyProps={{ color: "#4b445b", fontSize: 14 }}
                    secondaryTypographyProps={{ color: "#6b6478", fontSize: 12 }}
                  />
                </ListItem>
              ))
            ) : (
              <Typography variant="body2" sx={{ color: "#6b6478", mt: 1 }}>
                No users match.
              </Typography>
            )}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
